// extracted by mini-css-extract-plugin
export default {"FormWrapper":"AddEventForm_FormWrapper__e69bI"};